import { Alert } from '@skupreme/shared/ui';
import { FormPasswordField, FormTextField } from '@skupreme/shared/ui/form';
import { QuantityTypeField } from './QuantityTypeField';
import type { StepProps } from './types';

export function ExtensivStep({ control, fieldError, isVisible }: StepProps) {
  return (
    <div className={isVisible ? 'sk:flex sk:flex-col sk:gap-4' : 'sk:hidden'}>
      <Alert tone="info">
        For assistance with finding your REST API Keys,{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://help.extensiv.com/rest-api/getting-started-with-credential-management?from_search=122460479"
        >
          please review this document
        </a>
        . If you do not have access to the REST API Keys, please contact the
        Extensiv Warehouse you are working with for this project and have them
        submit a request for REST API access to their Extensiv Customer Success
        Manager.
      </Alert>
      <FormTextField
        control={control}
        name="clientName"
        label="User Name"
        error={fieldError('clientName')}
        isRequired={isVisible}
      />
      <FormTextField
        control={control}
        name="client_id"
        label="Client Id"
        error={fieldError('client_id')}
        isRequired={isVisible}
      />
      <FormPasswordField
        control={control}
        name="client_secret"
        label="Client Secret"
        error={fieldError('client_secret')}
        isRequired={isVisible}
      />
      <QuantityTypeField control={control} />
    </div>
  );
}
